import { apiClient } from '../utils/api';

export interface DashboardApiResponse {
  orders: {
    thisMonth: number;
    changeFromLastMonth: number;
    totalOrders: number;
  };
  earnings: {
    thisMonth: number;
    changeFromLastMonth: number;
    totalEarned: number;
    currency: string;
  };
  chart: {
    filter: string;
    categories: string[];
    orders: number[];
    revenue: number[];
    feedbacks: number[];
    questions: number[];
  };
  profileViews: {
    last30Days: number;
    changeFromLastMonth: number;
    last7Days: number;
    isPlanned?: boolean;
    message?: string;
  };
  searchStats: {
    appearsInSearches: number;
    changeFromLastMonth: number;
    clickThroughRate: number;
    isPlanned?: boolean;
    message?: string;
  };
  mostOrdered: Array<{
    rank: number;
    productId: string;
    title: string;
    price: number;
    orders: number;
    image: string;
  }>;
}

// Get dashboard data
export const getDashboardData = async (): Promise<DashboardApiResponse> => {
  const response = await apiClient.get<DashboardApiResponse>('/vendors/dashboard');
  return response.data;
};

// Get dashboard data with specific time filter (you can implement this when the API endpoint supports it)
export const getDashboardDataWithFilter = async (filter: string): Promise<DashboardApiResponse> => {
  const response = await apiClient.get<DashboardApiResponse>(`/vendors/dashboard?filter=${filter}`);
  return response.data;
};



